/* eslint-disable complexity */
import i18n from '@/lang';
import { IRequireLevel, INation, systemModule } from '@/store/modules/ModuleSystem';
import router from '@/router';
import { IUserData } from '@/store/modules/ModuleUser';

// 工作流type
export const WORKFLOW_TYPE = {
	ACCEPTANCE: 'acceptance'
};

export const LOCAL_STORE_USER_INFO = 'user-info';

/** 上一次访问地址 KEY */
export const LAST_INVOKE_PERMISSION_URL: string = 'LAST_INVOKE_PERMISSION_URL';

/** 当在403页面时临时存储内容 */
export const TEMP_PERMISSION_URL: string = 'TEMP_PERMISSION_URL';

/** 403KEY */
export const FORBIDDEN_PAGE: string = '/403';

/** 403是否跳转的字段名 */
export const FORBIDDEN_CONFIG_REDIRECT: string = 'forbidden_redirect';

/** 首页地址 */
export const SECOND_HOME_PAGE: string = '/home/homePage';

/**
 * 组装用户KEY
 *
 * @export
 * @param {any} key
 * @param {IUserData} userData
 * @returns {string}
 */
export function getLastInvokeUserKey(key: string, userData: IUserData): string {
	if (userData && userData.id) {
		return `${userData.id}-${key}`;
	}

	return key;
}

/**
 * 检测是否为中文
 *
 * @export
 * @param {string} str
 * @returns {boolean}
 */
export function checkChinese(str: string): boolean {
	const reg: RegExp = /[\u4e00-\u9fa5]+/;
	let flag: boolean = true;
	if (!reg.test(str)) {
		flag = false;
	}

	return flag;
}

/**
 * 获取模型类型中文说明
 *
 * @export
 * @param {*} type
 * @returns {string}
 */
export function getModelTypeText(type: any): string {
	let result: string = '';

	switch (type) {
		case 'A':
			result = 'AMS广告';
			break;
		case 'B':
			result = '非生产型';
			break;
		case 'C':
			result = '生产型';
			break;
		case 'D':
			result = '互联金融类';
			break;
		case 'F':
			result = '海外型';
			break;
		default:
			result = '未知模型';
			break;
	}

	return result;
}

/**
 * 获取付款状态中文说明
 *
 * @export
 * @param {*} type
 * @returns {string}
 */
export function getPayStatus(type: any): string {
	let result: string = '';

	switch (type) {
		case 1:
			result = '待付款';
			break;
		case 2:
			result = '付款中';
			break;
		case 3:
			result = '已付款';
			break;
		case 4:
			result = '付款失败';
			break;
		default:
			result = '未付款';
			break;
	}

	return result;
}

/**
 * 获取订单状态中文说明
 *
 * @export
 * @param {*} type
 * @returns {string}
 */
export function getOrderTypDesc(type: any): string {
	let result: string = '';

	if (type) {
		switch (type) {
			case 1:
				result = '标准订单';
				break;
			case 2:
				result = '一揽子订单';
				break;
			case 3:
				result = '一揽子协议';
				break;
		}
	}

	return result;
}

/**
 * 将状态转换成EL-TAG样式类型
 * 例如:
 * <el-tag type="success">显示内容</el-tag>
 */
export function statusTagClass(status: string): string {
	let statusVal: string = 'info';
	switch (status) {
		// 红色
		case 'cancelled':
			statusVal = 'danger';
			break;
		// 绿色
		case 'approved':
		case 'audited':
			statusVal = 'success';
			break;
		// 普通色
		case 'draft':
		case 'DRAFT':
			statusVal = 'warning';
			break;

		// 黄色
		default:
			statusVal = 'warning';
			break;
	}

	return statusVal;
}

/**
 * 依据后台传入状态获取需求状态中文说明
 * 注意: 所有状态函数从这里取
 *  */
export const statusEvent: any = (str: any, type: string = 'default'): any => {
	let result: string = '';

	switch (str) {
		// 草稿
		case 'Apply':
		case 'DRAFT':
		case 'draft':
			result = i18n.messages[i18n.locale].msg.status.draft;
			break;
		// 相关审批人审批
		case 'relateApprovalAudit':
			result = i18n.messages[i18n.locale].msg.status.relateApprovalAudit;
			break;
		// 相关审批人审批-账单模块
		case 'Relater':
			result = i18n.messages[i18n.locale].msg.status.relateApprovalAudit;
			break;
		// 相关审批人审批-决策模块
		case 'relaterApproval':
			result = i18n.messages[i18n.locale].msg.status.relateApprovalAudit;
			break;
		// 等待供应商确认
		case 'vendorConfirm':
		case 'SUPPLIER_AUDIT':
			result = i18n.messages[i18n.locale].msg.status.vendorConfirm;
			break;
		// 采购确认
		case 'purchaserConfirm':
			result = i18n.messages[i18n.locale].msg.status.purchaserConfirm;
			break;
		// 已进价格库
		case 'priceLibrary':
			result = i18n.messages[i18n.locale].msg.status.priceLibrary;
			break;
		// 业务总监/授权人审批
		case 'leaderOrDirectorAudit':
			result = i18n.messages[i18n.locale].msg.status.leaderAudit;
			break;
		case 'Leader':
			// 业务总监-账单
			let statusKey = 'centerChargerAudit';
			if (type === WORKFLOW_TYPE.ACCEPTANCE) {
				// 验收类型 => Leader审批
				statusKey = 'leaderAudit';
			}

			result = i18n.messages[i18n.locale].msg.status[statusKey];
			break;
		// 直属Leader审批
		case 'leaderAudit':
			// 直属Leader审批
			result = i18n.messages[i18n.locale].msg.status.leaderAudit2;
			break;
		// 中心负责人审批
		case 'centerChargerAudit':
		case 'majordomoApprovalAudit':
			result = i18n.messages[i18n.locale].msg.status.centerChargerAudit;
			break;
		// 系统处理中
		case 'processing':
		case 'PROCESSING':
			result = i18n.messages[i18n.locale].msg.status.processing;
			break;
		// 财管审核
		case 'financeAudit':
			result = i18n.messages[i18n.locale].msg.status.financeAudit;
			break;
		// 合同审核
		case 'ContractAudit':
			result = i18n.messages[i18n.locale].msg.status.contractAudit;
			break;
		// 税务审核
		case 'TaxAudit':
			result = i18n.messages[i18n.locale].msg.status.taxAudit;
			break;
		// 待供应商确认接单
		case 'pendingConfirm':
			result = i18n.messages[i18n.locale].msg.status.pendingConfirm;
			break;
		// 部门税务审批
		case 'deptTaxAudit':
			result = i18n.messages[i18n.locale].msg.status.deptTaxAudit;
			break;
		// 部门财管审批
		case 'deptFinanceAudit':
			result = i18n.messages[i18n.locale].msg.status.deptFinanceAudit;
			break;
		// 业务GM审批
		case 'GMAudit':
			result = i18n.messages[i18n.locale].msg.status.GMAudit;
			break;
		// GM审批(IEG模式下为经办人GM审批)
		case 'GMAuditIEG':
			result = i18n.messages[i18n.locale].msg.status.GMAuditIEG;
			break;
		// 业务GM审批-账单模块
		case 'BizGM':
			result = i18n.messages[i18n.locale].msg.status.GMAudit;
			break;
		// 财务DC审批
		case 'financeDCAudit':
			result = i18n.messages[i18n.locale].msg.status.financeDCAudit;
			break;
		// EVP审批
		case 'EVPAudit':
			result = i18n.messages[i18n.locale].msg.status.EVPAudit;
			break;
		// CXO审批
		case 'CXOAudit':
			result = i18n.messages[i18n.locale].msg.status.CXOAudit;
			break;
		// CFO审批
		case 'CFOAudit':
			result = i18n.messages[i18n.locale].msg.status.CFOAudit;
			break;
		// CEO审批
		case 'CEOAudit':
			result = i18n.messages[i18n.locale].msg.status.CEOAudit;
			break;
		// 经办人总监审批
		case 'CenterChargerAudit':
			result = i18n.messages[i18n.locale].msg.status.CenterChargerAudit;
			break;
		// 总裁审批
		case 'chairmanAudit':
		case 'ChairmanAudit':
			result = i18n.messages[i18n.locale].msg.status.chairmanAudit;
			break;
		// 已生效
		case 'effective':
			result = i18n.messages[i18n.locale].msg.status.effective;
			break;
		// 已终止
		case 'terminated':
			result = i18n.messages[i18n.locale].msg.status.terminated;
			break;
		// 已终止
		case 'stopped':
			result = i18n.messages[i18n.locale].msg.status.stopped;
			break;
		// 已删除
		case 'deleted':
			result = i18n.messages[i18n.locale].msg.status.deleted;
			break;
		// 部分验收
		case 'partialAcceptance':
			result = i18n.messages[i18n.locale].msg.status.partialAcceptance;
			break;
		// 待验收
		case 'pendingAcceptance':
			result = i18n.messages[i18n.locale].msg.status.pendingAcceptance;
			break;
		// 部分验收
		case 'partAcceptance':
			result = i18n.messages[i18n.locale].msg.status.partAcceptance;
			break;
		// 验收中
		case 'inAcceptance':
			result = i18n.messages[i18n.locale].msg.status.inAcceptance;
			break;
		// 已验收
		case 'acceptance':
			result = i18n.messages[i18n.locale].msg.status.acceptance;
			break;
		// 已作废
		case 'invalid':
			result = i18n.messages[i18n.locale].msg.status.invalid;
			break;
		// 经办人审批
		case 'agentAudit':
		case 'AgentAudit':
			result = i18n.messages[i18n.locale].msg.status.agentAudit;
			break;
		// 业务总监审批
		case 'centerCharger':
		case 'CenterCharger':
			result = i18n.messages[i18n.locale].msg.status.centerCharger;
			break;
		// 采购审批
		case 'purchaseAudit':
		case 'PurchaseAudit':
			result = i18n.messages[i18n.locale].msg.status.purchaseAudit;
			break;

		// 业务线财管审批
		case 'businessFinancialAudit':
			result = i18n.messages[i18n.locale].msg.status.businessFinancialAudit;
			break;
		// 业务部门负责人审批
		case 'businessDeptHeadAudit':
			result = i18n.messages[i18n.locale].msg.status.businessDeptHeadAudit;
			break;
		// 产业生态合作部负责人审批
		case 'coopDeptHeadAudit':
			result = i18n.messages[i18n.locale].msg.status.coopDeptHeadAudit;
			break;
		// 审批完成
		case 'audited':
			result = i18n.messages[i18n.locale].msg.status.audited;
			break;
		// 已作废
		case 'cancelled':
			result = i18n.messages[i18n.locale].msg.status.cancelled;
			break;
		// 供应商已确认
		case 'vendorAlreadyConfirm':
			result = i18n.messages[i18n.locale].msg.status.vendorAlreadyConfirm;
			break;
		// 已完成
		case 'finished':
		case 'FINISH':
			result = i18n.messages[i18n.locale].msg.status.finished;
			break;
		// 已审批
		case 'End':
		case 'approved':
			result = i18n.messages[i18n.locale].msg.status.approved;
			break;
		// 业务方确认
		case 'BusinessConfirm':
		case 'businessConfirm':
			result = i18n.messages[i18n.locale].msg.status.businessConfirm;
			break;
		// 已确认
		case 'confirm':
			result = i18n.messages[i18n.locale].msg.status.confirm;
			break;
		// 相关审批人审批
		case 'relaterAudit':
			result = i18n.messages[i18n.locale].msg.status.relaterAudit;
			break;
		// 买方确认中
		case 'buyerConfirm':
			result = i18n.messages[i18n.locale].msg.status.buyerConfirm;
			break;
		// 原创馆审批
		case 'originalMuseumAudit':
			result = i18n.messages[i18n.locale].msg.status.originalMuseumAudit;
			break;
		// 已退货
		case 'returned':
			result = i18n.messages[i18n.locale].msg.status.returned;
			break;
		// 供应商确认中
		case 'SupplierConfirm':
		case 'supplierConfirm':
			result = i18n.messages[i18n.locale].msg.status.supplierConfirm;
			break;
		// case 'SUPPLIER_AUDIT':
		// result = i18n.messages[i18n.locale].msg.status.finished;
		// break;
		case 'SUPPLIER_AGREE':
			result = i18n.messages[i18n.locale].msg.status.confirm;
			// result = '供应商确认';
			break;
		// case 'SUPPLIER_REFUSE':
		// result = i18n.messages[i18n.locale].msg.status.finished;
		// result = '供应商拒绝';
		// break;

		// 简单
		case 'simple':
			result = i18n.messages[i18n.locale].msg.status.simple;
			break;
		// 复杂
		case 'complex':
			result = i18n.messages[i18n.locale].msg.status.complex;
			break;
		// 询价中
		case 'enquirying':
			result = i18n.messages[i18n.locale].msg.status.enquirying;
			break;
		//  已报价
		case 'quoted':
			result = i18n.messages[i18n.locale].msg.status.quoted;
			break;
		// 打开报价
		case 'opened':
			result = i18n.messages[i18n.locale].msg.status.opened;
			break;
		// 已生成价格库
		case 'priceLibrarying':
			result = i18n.messages[i18n.locale].msg.status.priceLibrarying;
			break;
		// 部门GM审批
		case 'deptGMAudit':
			result = i18n.messages[i18n.locale].msg.status.deptGMAudit;
			break;
		// isux-GM审批
		case 'isuxGMAudit':
		case 'IsuxGM':
			result = i18n.messages[i18n.locale].msg.status.isuxGMAudit;
			break;
		// 产业生态合作部GM审批
		case 'coopDeptAudit':
			result = i18n.messages[i18n.locale].msg.status.coopDeptAudit;
			break;
		// 财管审批
		case 'Finance':
		case 'financialAudit':
			result = i18n.messages[i18n.locale].msg.status.financialAudit;
			break;
		// 直属leader审批
		case 'leaderApprovalAudit':
			result = i18n.messages[i18n.locale].msg.status.leaderApprovalAudit;
			break;
		// 待汇总审批
		case 'pendingSummary':
			result = i18n.messages[i18n.locale].msg.status.pendingSummary;
			break;
		// 已汇总待审批
		case 'summary':
			result = i18n.messages[i18n.locale].msg.status.summary;
			break;
		// 已驳回
		case 'rejected':
			result = i18n.messages[i18n.locale].msg.status.rejected;
			break;
		// 已取消
		case 'canceled':
			result = i18n.messages[i18n.locale].msg.status.canceled;
			break;
		// 数据同步中
		case 'Syncing':
		case 'syncing':
			result = i18n.messages[i18n.locale].msg.status.syncing;
			break;
		// 待付款
		case 'INIT':
			result = i18n.messages[i18n.locale].msg.status.init;
			break;
		// 处理中
		case 'PROCESS':
			result = i18n.messages[i18n.locale].msg.status.processVal;
			break;
		// 处理成功
		case 'SUCCESS':
			result = i18n.messages[i18n.locale].msg.status.success;
			break;
		// 付款失败
		case 'FAIL':
			result = i18n.messages[i18n.locale].msg.status.fail;
			break;
		// 已拒绝
		case 'SUPPLIER_REFUSE':
			result = i18n.messages[i18n.locale].msg.status.supplier_refuse;
			break;
		// 待补充审批邮件
		case 'toAddedApprovalMail':
		case 'AddApprovalMail':
			result = i18n.messages[i18n.locale].msg.status.toAddedApprovalMail;
			break;
		// 已关闭验收
		case 'closeAcceptance':
			result = i18n.messages[i18n.locale].msg.status.closeAcceptance;
			break;
		// 审批完成
		case 'approvalCompleted':
			result = i18n.messages[i18n.locale].msg.status.approvalCompleted;
			break;
		default:
			result = i18n.messages[i18n.locale].msg.status.draft;
			break;
	}

	return result;
};

/**
 * 检测是否为第一次未保存模式
 *
 * @param {*} vueObj
 *
 * @memberOf ControllerDemandEntry
 */
export function checkDraftMode(vueObj: any): boolean {
	let result: boolean = false;

	// 同时判断有无本地内容
	if (vueObj.$route.query.code) {
		result = true;
	}

	return result;
}

/** SORT ARR */
export function sortArr(arr: Array<any>, str: any): any {
	const localArr = [];
	let tempArr = [];
	let tempVal = '';
	let localStr = '';

	// 按照特定的参数将数组排序将具有相同值得排在一起
	arr = arr.sort((a, b) => {
		const s = a[str];
		const t = b[str];

		return s < t ? -1 : 1;
	});
	if (arr.length) {
		tempVal = arr[0][str];
	}

	// 将相同类别的对象添加到统一个数组
	for (const i in arr) {
		if (arr[i][str] === tempVal) {
			tempArr.push(arr[i]);
		} else {
			tempVal = arr[i][str];
			localArr.push(tempArr);
			tempArr = [arr[i]];
		}
	}

	// 将最后的内容推出新数组
	localArr.push(tempArr);
	localArr.forEach((item, i) => {
		// localStr += item[0].taskName + ":";  //当前处理人不要相关人审批人审批
		item.forEach((val, index) => {
			if (index + 1 === item.length && i + 1 === localArr.length) {
				localStr += `${val.ownerName}${val.taskName}`;
			} else {
				localStr += `${val.ownerName}${val.taskName}；`;
			}
		});
	});

	return localStr;
}

/**
 * 订单审批记录状态
 *
 * @export
 * @param {*} type
 * @returns {string}
 */
export function getActiveStatus(type: any): string {
	let result: string = '';

	if (type) {
		switch (type) {
			case 'submit':
				result = '提交';
				break;
			case 'agree':
				result = '同意';
				break;
			case 'reject':
				result = '驳回';
				break;
			case 'transfer':
				result = '转交';
				break;
			case 'revoke':
				result = '撤回';
				break;
			case 'runTo':
				result = '跳转';
				break;
			case 'cancel':
				result = '取消';
				break;
		}
	}

	return result;
}

/**
 * 重组参数获取价格库
 * arr 数组
 */
export function priceSortArr(arr: Array<any>): any {
	const codesArr: Array<string> = [];
	const levelArr: Array<string> = [];
	let localObj: any = {};

	for (let i = 0; i < arr.length; i++) {
		const element = arr[i];

		// 物料code
		if (codesArr.indexOf(element.materialCode) === -1) {
			codesArr.push(element.materialCode);
		}

		// 需求等级
		if (levelArr.indexOf(element.requirementLevel) === -1 && element.requirementLevel) {
			levelArr.push(element.requirementLevel);
		}

		if (levelArr.indexOf(element.level) === -1 && element.level) {
			levelArr.push(element.level);
		}
	}

	localObj = {
		codesArr,
		levelArr
	};

	return localObj;
}

/** 需求等级数据 */
let requireLevelsList: Array<IRequireLevel> = [];

/**
 * 获取需求等级数据
 *
 * @export
 * @returns {Array<IRequireLevel>}
 */
export function getRequireLevelListData(): Array<IRequireLevel> {
	if (requireLevelsList.length === 0) {
		requireLevelsList = systemModule.requireLevelsList;
	}

	return requireLevelsList;
}

/**
 * 需求等级映射
 *
 * @export
 * @param {string} value 需求等级对应值
 * @returns {string}
 */
export function getRequireLevelDescByValue(value: string): string {
	let result = '';

	if (value) {
		const innerRequireList: Array<IRequireLevel> = getRequireLevelListData();
		for (let index = 0; index < innerRequireList.length; index++) {
			const element: IRequireLevel = innerRequireList[index];

			if (element.value === value || element.code === value) {
				result = element.label || '';

				break;
			}
		}
	}

	return result;
}

/**
 * 业务创场景映射
 * @export
 * @param {string} val 业务场景对应的值
 * @returns {string}
 */
export function getBusinessSceneCorrespondingValue(val: string): string {
	let result: string = '';

	switch (val) {
		case 'QCP':
			result = '内容设计采购模式';
			break;
		default:
			result = '';
			break;
	}

	return result;
}

/** 国家地区数据 */
let nationList: Array<INation> = [];

/**
 * 获取国家地区数据
 *
 * @export
 * @returns {Array<INation>}
 */
export function getNationListData(): Array<INation> {
	if (nationList.length === 0) {
		nationList = systemModule.nationList;
	}

	return nationList;
}

/**
 * 国家地区映射
 *
 * @export
 * @param {string} value 国家地区对应值
 * @returns {string}
 */
export function getnationListByValue(value: number): string {
	let result = '';

	if (value) {
		const innerRequireList: Array<INation> = getNationListData();
		for (let index = 0; index < innerRequireList.length; index++) {
			const element: INation = innerRequireList[index];

			if (element.value === value) {
				result = element.label || '';

				break;
			}
		}
	}

	return result;
}

/**
 * 依据TYPE获取参数上对应页面ID
 *
 * @param {any} type
 */
export function getReportIdByType(type: string): any {
	let customReportIds = router?.history?.current?.query?.customReportIds || {};

	if (customReportIds) {
		try {
			customReportIds = JSON.parse(customReportIds);
		} catch (error) {
			console.log('getReportIdByType parse error', error);
		}
	}

	if (type && customReportIds[type]) {
		return customReportIds[type];
	}

	console.log(`${type} 类型未找到`);

	return '';
	// http://dev.bfc.woa.com/pages#/settlement/settlementDetails?id=id&customReportIds={"targetModule":"BILL","basicInfoReportId":"RPT202110000413","redirectType":"custom_redirect","detailInfoReportId":"RPT202110000426"}
}

/**
 * 格式化处理部门（多个 | 分隔时，去取最后 | 分隔的部门）
 */
export function processingDepartmentName(name: string): string {
	let deptNameList: Array<string> = [];
	if (name && name.indexOf('|') !== -1) {
		deptNameList = name.split('|');
	}

	console.log(deptNameList);

	return deptNameList[length - 1];
}

/** 我方主体 */
export const OURS_MATAINS: string = 'our-matains';

/** 其他我方主体 */
export const OTHER_OURS_MATAINS: string = 'other-our-matains';

/** 采购类别 */
export const PURCHASE_TYPE: string = 'purchase-type';

/** 供应商选择方法 */
export const SUPPLIER_TYPE: string = 'supplier-type';

/** 预计验收日期 */
export const CHECK_DATE: string = 'check-date';

/** 交付方式 */
export const ACCEPTANCE_TYPE: string = 'acceptance-type';

/** 电子合同&盖章归档 */
export const STAMP_STATUS: string = 'stamp-status';

/** 订单类型 */
export const ORDER_TYPE: string = 'order-type';

/** 采购明细 */
export const PURCHASE_DETAILS: string = 'purchase-details';

/** 订单执行情况 */
export const ORDER_PROJECT: string = 'order-project';

/** 添加行 */
export const ADD_LINE: string = 'add-line';

/** 最后一次验收 */
export const LAST_ACCEPT: string = 'last-accept';

/** 验收方式 */
export const ACCEPT_TYPE: string = 'accept-type';

/** 中标方案书 */
export const LETTER_ACCEPTANCE: string = 'letter-acceptance';

/**
 * 获取帮助链接
 *
 * @export
 * @param {string} type
 * @returns {string}
 */
export function getHelpDescription(type: string): string {
	let result: string = '';
	switch (type) {
		case OURS_MATAINS:
			result = `
			1、触发购汇规则：
			我方主体是：中国大陆或境内，他方主体非中国大陆或境内时，将需要触发购汇，提交订单时，系统会通过购汇平台通知税务人员进行备案资料准备；
			订单审批完成后，再次通过购汇平台通知税务人员进行备案资料上传

			2、金额大于指定的金额（如100万人民币）在税务审核环节，税务人员可以进行税务台账录入；
			金额小于指定的金额，可以由税务人员进行“税务台账待办”进行填写税务台账信息
			`;
			break;
		case PURCHASE_TYPE:
			result = `
			1、大市场管控
			公司大市场中台规则时，要求订单采购明细必须来源于中标方案书，否则无法提交。
			当订单录入内容中：选择的采购类别、经办部门组合在配置范围内且供应商国家地区为境内即需要进行管控

			采购类别：所有营销推广采购类别排除以下类别
			\\营销推广\\赞助合作
			\\营销推广\\其它
			\\营销推广\\预装内置
			\\营销推广\\奖金补助劳务费
			\\营销推广\\名人合作
			\\营销推广\\专项运营
			\\营销推广\\渠道推广

			经办部门：IEG所有部门
			供应商国家地区：境内供应商

			2、订单执行明细导入模版：
			包含通用模版、买量模版、非买量模版，当采购类别为“媒介投放”时可以通过买量模版、非买量模版进行导出、导入；
			其他采购类别可以通过通用模版进行导出、导入
			`;
			break;
		case OTHER_OURS_MATAINS:
			result = `
			签订多方合同时，请在其他我方主体、其他供应商分别添加其他我方、他方签约主体
			`;
			break;
		case SUPPLIER_TYPE:
			result = `
			1、竞争性综合评估：通过对备选供应商的技术方案和商务报价设置相应权重来综合评估，而最终选择合作供应商。

			2、比稿：主要根据备选供应商技术方案进行评估，商务报价仅作为参考，而最终选择合作供应商。

			3、价格比较：在备选供应商均满足供应要求的前提下，对供应商报价信息进行比较，选取具有价格优势的供应商。

			4、独家供应商：受到供方市场资源垄断性限制而仅能够选择唯一供应商的情况，一般为行业、市场资源垄断或专利技术垄断类供应商。

			5、指定供应商：因业务原因，虽然该供应商所供产品或服务在市场仍存在其它可替代供应商，但业务方仍指定性地选择该供应商提供产品或服务。

			6、合约到期续签：在与原供应商签订的合作协议到期后，通过合同延续的方式选择同一供应商。
			`;
			break;
		case CHECK_DATE:
			result = `
			如有多次验收，请填写首次验收日期
			`;
			break;
		case ACCEPTANCE_TYPE:
			result = `
			1、业务验收：业务直接发起订单验收，填写全部验收信息，无需供应商在协同中发起验收

			2、协同验收：供应商发起验收，填写供应商需填写的部分信息，提交后由业务验收确认及需业务填写的部分信息；

			3、当选择协同验收时系统会校验供应商是否已经注册，请确保在选择协同验收前已经选择供应商

			4、协同验收时通常供应商具备在线回签条件，建议协同验收时需要回签的，回签方式选择“协同”
			`;
			break;
		case STAMP_STATUS:
			result = `
			1、选择生成合同，则需要上传合同附件，填写合同相关信息，订单审批完成推送合同系统，产生合同号码。

			2、选择【需要】盖章归档，则生成合同后，需要去合同管理系统进行相关的盖章归档操作，盖章归档操作请咨询连线财经2-8003(合同与公章)

			3、选择【无需】盖章归档，则生成的合同无法进行盖章归档操作，可能会产生相关风险。

			4、选择不生成合同，订单审批完成后不会生成合同，可能会影响付款，请跟部门财管确认后选择。
			`;
			break;
		case ORDER_TYPE:
			result = `
			1、标准订单：固定采购单价和采购数量的订单请选择此项，选择此项后验收时采购项目不可修改，总金额不可超出（可下调）。可一次性或分次执行验收，可一次性或分次付款。

			2、一揽子订单：按实际采购量结算、固定采购单价，数量不定的订单请选择此项，可一次性或分次执行验收，可一次性或分次付款。
			`;
			break;
		case PURCHASE_DETAILS:
			result = `
			1、经办部门、采购类别组合符合管控规则且供应商国家地区为境内的，采购明细需要关联通过SMS（供应商招投标系统）走完流程的中标方案书，以加载采购明细

			2、不在管控范围的，需要手动添加采购明细
				`;
			break;
		case ORDER_PROJECT:
			result = `
			订单执行明细导入模版：
			包含通用模版、买量模版、非买量模版，当采购类别为“媒介投放”时可以通过买量模版、非买量模版进行导出、导入；
			其他采购类别可以通过通用模版进行导出、导入
			`;
			break;
		case ADD_LINE:
			result = `
			添加未加入此次订单项目执行情况的立项中的资源类型，以及该资源类型下的场景
			`;
			break;
		case LAST_ACCEPT:
			result = `
			如果交付方式是协同验收，供应商选择发起验收的验收单，由供应商指定是否最后一次验收，业务不能再选择
			`;
			break;
		case ACCEPT_TYPE:
			result = `
			默认按数量，带中标方案书只能按数量，隐藏按金额选项，如果交付方式是协同验收，供应商选择发起验收的验收单，由供应商指定验收的方式，业务不能再选择
			`;
			break;
		case LETTER_ACCEPTANCE:
			result = `
			INI开头标书单号为系统初始化数据，缺失报价明细
			`;
			break;

		default:
			break;
	}

	return result;
}

/** 公共模糊查询接口传参 */
export const SELECT_TYPE_LIST: Array<any> = [
	// 通用
	'common_is', // 是否
	'INDEX_PS', // 产权状况
	'INDEX_SD', // 销售地区
	'INDEX_CSB', // 控股股东背景
	'INDEX_LRPCS', // 法人代表个人信用评价
	'INDEX_OCEIDX', // 外部信用评估
	'INDEX_RCRIDX', // 股权关联关系
	'INDEX_SKSIDX', // 股权结构
	'INDEX_TTSIDX', // 与腾讯交易违规行为
	'INDEX_OENIDX', // 异常经营
	'INDEX_PMRIDX', // 行政处罚记录
	'INDEX_EPRIDX', // 资产抵押/股权出质记录
	'INDEX_BKRIDX', // 公司法院失信被执行人信息
	// 海外指标
	'INDEX_HW_AL', // 海外指标(资产负债率)
	'INDEX_HW_CT', // 海外指标(客户类型)
	'INDEX_HW_EON', // 海外指标(员工人数)
	'INDEX_HW_OCEIDX', // 海外指标(外部信用评估)
	'INDEX_HW_IDI', // 海外指标(行业5年增长率
	'INDEX_HW_NRF', // 海外指标(国家风险)
	'INDEX_HW_ORR', // 海外指标(营业收入
	'INDEX_HW_YOE', // 海外指标(成立年限)
	'INDEX_HW_PROFIT' // 海外指标(盈利能力（利润率）)
];

/**
 * 公共模糊查询接口参数
 *
 * @export
 * @param {string} type
 * @returns {string}
 */
export function getCommonSelectType(): any {
	const result: any = SELECT_TYPE_LIST.toString();

	return result;
}

/** CrossDomainSync 键：当前供应商 pVendorPartyId（用于跨 Tab/子域共享） */
export const CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE = 'pvendor-id';

/** 供应商共享埋点：事件标识前缀（pgvSendClick 的 hotTag 前缀） */
export const SUPPLIER_SHARE_EVENT_NAME: string = 'SUPPLIER_SHARE_VALUE';

/** 供应商共享埋点：上报字段 perfix（cookie 前缀） */
export const SUPPLIER_SHARE_PREFIX: string = '';

/** 供应商共享埋点：上报字段 domain（cookie 域名） */
export const SUPPLIER_SHARE_DOMAIN: string = '.tencent.com';

/** CrossDomainSync 构造选项：prefix 与 domain 必须在所有调用方保持一致，否则读写的是不同 Cookie */
export const CROSS_DOMAIN_SYNC_OPTIONS = {
	prefix: SUPPLIER_SHARE_PREFIX,
	domain: SUPPLIER_SHARE_DOMAIN
};
